import { useState } from "react";
import { testimonials } from "@/mocks/home";

export default function Testimonials() {
  const [activeIndex, setActiveIndex] = useState(0);

  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 font-heading mb-4">
            客户真实评价
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
            超过50,000位客户的信任之选，听听他们怎么说
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8 max-w-5xl mx-auto">
          {testimonials.map((testimonial, index) => (
            <div
              key={testimonial.id}
              className={`bg-background-100 rounded-lg p-6 md:p-7 border transition-all duration-300 cursor-pointer ${
                activeIndex === index
                  ? "border-primary-300/70"
                  : "border-background-200/50 hover:border-background-300"
              }`}
              onClick={() => setActiveIndex(index)}
            >
              <div className="flex items-center gap-1 mb-4">
                {Array.from({ length: testimonial.rating }).map((_, i) => (
                  <i key={i} className="ri-star-fill text-sm text-primary-400"></i>
                ))}
              </div>
              <p className="text-sm text-foreground-700 leading-relaxed mb-5">
                &ldquo;{testimonial.content}&rdquo;
              </p>
              <div className="flex items-center gap-3 pt-4 border-t border-background-200/50">
                <div className="w-10 h-10 bg-accent-200 rounded-full flex items-center justify-center">
                  <span className="text-sm font-bold text-accent-700 font-heading">
                    {testimonial.name.charAt(0)}
                  </span>
                </div>
                <div>
                  <div className="text-sm font-semibold text-foreground-900">
                    {testimonial.name}
                  </div>
                  <div className="text-xs text-foreground-500">
                    {testimonial.role} · {testimonial.location}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="flex justify-center gap-2 mt-8 md:hidden">
          {testimonials.map((_, index) => (
            <button
              key={index}
              onClick={() => setActiveIndex(index)}
              className={`w-2 h-2 rounded-full transition-all duration-300 ${
                activeIndex === index
                  ? "bg-primary-500 w-6"
                  : "bg-background-300"
              }`}
              aria-label={`查看第${index + 1}条评价`}
            />
          ))}
        </div>
      </div>
    </section>
  );
}